import { PageState } from "../global";
import { CHANGE_PAGE } from "./constants";


export const changePage = (page: PageState) => ({
    page,
    type: CHANGE_PAGE,
});